import menu from './menu.json';

export default {
  menu,
};
